export default __webpack_public_path__ + "static/media/DogHappy.886f0e42.svg";